"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6481],{

/***/ 45265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const HeroDividerBottom = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "section-hero__divider-bottom"
    });
/* harmony default export */ __webpack_exports__["Z"] = (HeroDividerBottom);


/***/ }),

/***/ 13336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_RecommendedVideos_RecommendedVideos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/CardBlock/index.js + 5 modules
var CardBlock = __webpack_require__(62039);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/getContentProps.js
var getContentProps = __webpack_require__(76638);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/brand/Default.js







const RecommendedVideos = (param)=>{
    let { videos  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        isBorderNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                children: "Recommended Resources"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockRow */.nC, {
                children: videos.map((video)=>{
                    var ref;
                    const contentProps = (0,getContentProps/* default */.Z)(video.sys.contentType.sys.id);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockCol */.YT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* default */.ZP, {
                            LinkComponent: Link/* default */.Z,
                            cardType: contentProps.typePlaceholder,
                            titleText: video.fields.title,
                            imgSrc: ((ref = video.fields.thumbnail) === null || ref === void 0 ? void 0 : ref.fields.file.url) || "",
                            descriptionText: video.fields.metaDescription,
                            href: "".concat(contentProps.alias, "/").concat(video.fields.slug),
                            linkButtonText: contentProps.linkPlaceholder
                        })
                    }, video.sys_id);
                })
            })
        ]
    });
};
RecommendedVideos.propTypes = {
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var Default = (RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/brand/LabArchives.js







const LabArchives_RecommendedVideos = (param)=>{
    let { videos  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        isBorderNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                children: "Recommended Resources"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockRow */.nC, {
                children: videos.map((video)=>{
                    const contentProps = (0,getContentProps/* default */.Z)(video.sys.contentType.sys.id);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockCol */.YT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* default */.ZP, {
                            LinkComponent: Link/* default */.Z,
                            cardType: contentProps.typePlaceholder,
                            titleText: video.fields.title,
                            imgSrc: video.fields.thumbnail.fields.file.url,
                            descriptionText: video.fields.metaDescription,
                            href: "".concat(contentProps.alias, "/").concat(video.fields.slug),
                            linkButtonText: contentProps.linkPlaceholder
                        })
                    }, video.sys_id);
                })
            })
        ]
    });
};
LabArchives_RecommendedVideos.propTypes = {
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var LabArchives = (LabArchives_RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/RecommendedVideos.js






const RecommendedVideos_RecommendedVideos = (param)=>{
    let { brandCode , videos  } = param;
    const RecommendedVideosComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_LA */.gf:
                return LabArchives;
            default:
                return Default;
        }
    };
    const RecommendedVideosBrand = RecommendedVideosComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedVideosBrand, {
        videos: videos
    });
};
RecommendedVideos_RecommendedVideos.propTypes = {
    brandCode: prop_types.string,
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var components_RecommendedVideos_RecommendedVideos = (RecommendedVideos_RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/index.js



/***/ }),

/***/ 96481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Series; }
});

// UNUSED EXPORTS: fetchProps, fetchSlugs

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 11 modules
var i18 = __webpack_require__(8610);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var contentful_createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/index.js + 1 modules
var WistiaVideo = __webpack_require__(6292);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/names.js
var names = __webpack_require__(50334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/BlockDetail.js






const WistiaVideoBlockDetailFrame = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        md: 8,
        lg: 8,
        children: children
    });
};
WistiaVideoBlockDetailFrame.propTypes = {
    children: prop_types.node.isRequired
};
const WistiaVideoBlockDetailInfo = (param)=>/*#__PURE__*/ {
    let { title , children  } = param;
    return (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
        md: 4,
        lg: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "wistia-block-detail__title",
                children: title
            }),
            children
        ]
    });
};
WistiaVideoBlockDetailInfo.propTypes = {
    title: prop_types.string.isRequired,
    children: prop_types.node.isRequired
};
const WistiaVideoBlockDetailInfoItem = (param)=>/*#__PURE__*/ {
    let { title , children , iconName =""  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "wistia-block-detail__info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "wistia-block-detail__info-title",
                children: [
                    iconName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        spacing: {
                            mr: 2
                        },
                        name: iconName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "wistia-block-detail__info-description",
                children: children
            })
        ]
    });
};
WistiaVideoBlockDetailInfoItem.propTypes = {
    title: prop_types.string.isRequired,
    iconName: (0,prop_types.oneOf)(names/* default */.Z),
    children: prop_types.node.isRequired
};
const WistiaVideoBlockDetail = (param)=>{
    let { dataId , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-id": dataId,
        className: "wistia-block-detail",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            mx: true,
            my: true,
            children: children
        })
    });
};
WistiaVideoBlockDetail.propTypes = {
    dataId: prop_types.string.isRequired,
    children: prop_types.node.isRequired,
    videoEmbed: prop_types.node
};
/* harmony default export */ var BlockDetail = (WistiaVideoBlockDetail);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Hero_Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/WistiaVideoEmbed.js
var WistiaVideoEmbed = __webpack_require__(91623);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/HeroBrand.js
var HeroBrand = __webpack_require__(68103);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/SectionHero/brand/Default.js




const SectionHero = (param)=>{
    let { brandCode , heroConfig , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBrand/* default */.Z, {
        brandCode: brandCode,
        config: heroConfig,
        ...props
    });
};
SectionHero.propTypes = {
    brandCode: prop_types.string,
    heroConfig: prop_types.object
};
/* harmony default export */ var Default = (SectionHero);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/DividerBottom.js
var DividerBottom = __webpack_require__(45265);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/SectionHero/brand/Omiq.js





const Omiq_SectionHero = (param)=>{
    let { brandCode , heroConfig , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBrand/* default */.Z, {
        brandCode: brandCode,
        config: heroConfig,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerBottom/* default */.Z, {})
        ]
    });
};
Omiq_SectionHero.propTypes = {
    brandCode: prop_types.string,
    heroConfig: prop_types.object,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Omiq = (Omiq_SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/SectionHero/heroConfig.js
const heroConfig = {
    color: {
        sg: "black--02",
        gn: "white",
        gp: "gradient",
        om: "white",
        la: "4"
    }
};
/* harmony default export */ var SectionHero_heroConfig = (heroConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/SectionHero/SectionHero.js







const SectionHero_SectionHero = (param)=>{
    let { brandCode , children , ...props } = param;
    const HeroComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_OM */.h7:
                return Omiq;
            default:
                return Default;
        }
    };
    const HeroBrand = HeroComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBrand, {
        config: SectionHero_heroConfig,
        brandCode: brandCode,
        ...props,
        children: children
    });
};
SectionHero_SectionHero.propTypes = {
    brandCode: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var components_SectionHero_SectionHero = (SectionHero_SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/SectionHero/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/index.js + 3 modules
var RecommendedVideos = __webpack_require__(13336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/renderBlockByType.js + 23 modules
var renderBlockByType = __webpack_require__(94340);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/BackLink/BackLink.js






const BackLink = (param)=>{
    let { backLink: { href , title  }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        sx: {
            textAlign: "left"
        },
        spacing: {
            mb: 10
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
            href: href,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "chevron-left",
                    spacing: {
                        mr: 3
                    }
                }),
                title
            ]
        })
    });
};
BackLink.propTypes = {
    backLink: (0,prop_types.shape)({
        href: prop_types.string.isRequired,
        title: prop_types.string.isRequired
    })
};
/* harmony default export */ var BackLink_BackLink = (BackLink);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/Page.js




















const SeriesPage = (param)=>{
    let { video , pageProps  } = param;
    var ref, ref1, ref2;
    const [t] = (0,i18/* useLocale */.bU)("series");
    const { siteDomain , brandCode , backLink , academyToCComponent =null  } = pageProps;
    const { title , metaTitle ="" , metaDescription ="" , subtitle , slug , videos , thumbnail , recommendedVideos =[] , additionalResources =[] , academy =false  } = video;
    const brandName = constants/* BRAND_NAMES */.aU[brandCode];
    const thumbnailUrl = (thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) || "";
    let tocItems = videos.map((item)=>({
            title: item.fields.title,
            slug: item.sys.id
        }));
    tocItems = (academyToCComponent === null || academyToCComponent === void 0 ? void 0 : (ref2 = academyToCComponent.items) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? [
        ...tocItems,
        ...academyToCComponent.items
    ] : tocItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: "".concat(metaTitle, " - ").concat(brandName),
                description: metaDescription,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        siteName: t("META_SITE_NAME"),
                        title: "".concat(metaTitle, " - ").concat(brandName),
                        description: metaDescription,
                        url: "".concat(siteDomain, "/series/").concat(slug),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        image: thumbnailUrl || t("META_IMAGE"),
                        imageSecureUrl: thumbnailUrl || t("META_IMAGE_SECURE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META_TWITTER_CARD"),
                        site: t("META_TWITTER_SITE"),
                        creator: t("META_TWITTER_CREATOR"),
                        title: "".concat(metaTitle, " - ").concat(brandName),
                        description: metaDescription,
                        image: thumbnailUrl || t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "".concat(siteDomain, "/series/").concat(slug)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_SectionHero_SectionHero, {
                brandCode: brandCode,
                children: [
                    academy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroRow */.P, {
                        center: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                            md: 4,
                            spacing: {
                                mb: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: t("ACADEMY_LINK"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: t("ACADEMY_LOGO"),
                                    isBaseUrl: true
                                })
                            })
                        })
                    }),
                    backLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackLink_BackLink, {
                        backLink: backLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        children: subtitle
                    })
                ]
            }),
            academy && tocItems.length > 1 && (academyToCComponent.Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(academyToCComponent.Component, {
                items: tocItems
            }) : null),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                spacing: {
                    mt: 14,
                    py: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                    lg: 10,
                    center: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideo/* default */.Z, {
                        list: videos,
                        children: videos.map((item)=>{
                            const { fields , sys  } = item;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockDetail, {
                                id: sys.id,
                                dataId: sys.id,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoBlockDetailFrame, {
                                        dataId: sys.id,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed/* default */.Z, {
                                            url: fields.videoUrl
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(WistiaVideoBlockDetailInfo, {
                                        title: fields.title,
                                        children: [
                                            (fields === null || fields === void 0 ? void 0 : fields.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoBlockDetailInfoItem, {
                                                title: t("VIDEO_SUBTITLE_TEXT"),
                                                children: fields.description
                                            }) : null,
                                            (fields === null || fields === void 0 ? void 0 : fields.lengthString) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoBlockDetailInfoItem, {
                                                title: t("VIDEO_SUBTITLE_LENGTH"),
                                                children: fields.lengthString
                                            }) : null
                                        ]
                                    })
                                ]
                            }, fields.title);
                        })
                    })
                })
            }),
            recommendedVideos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedVideos/* default */.Z, {
                brandCode: brandCode,
                videos: recommendedVideos
            }),
            additionalResources.map((0,renderBlockByType/* default */.Z)(slug))
        ]
    });
};
SeriesPage.propTypes = {
    video: (0,prop_types.shape)({
        title: prop_types.string.isRequired,
        subtitle: prop_types.string.isRequired,
        metaDescription: prop_types.string,
        slug: prop_types.string.isRequired,
        body: prop_types.object,
        toCLink: prop_types.string
    }),
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string,
        brandCode: prop_types.string,
        backLink: (0,prop_types.shape)({
            title: prop_types.string.isRequired,
            href: prop_types.string.isRequired
        }),
        academyToCComponent: (0,prop_types.shape)({
            Component: prop_types.elementType,
            items: (0,prop_types.arrayOf)((0,prop_types.shape)({
                title: prop_types.string.isRequired,
                slug: prop_types.string.isRequired
            }))
        })
    })
};
/* harmony default export */ var Page = (SeriesPage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/contentfulSanitizer.js
var contentfulSanitizer = __webpack_require__(50420);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/index.js











const fetchSlugs = async (contentfulProps)=>{
    const client = createClient(contentfulProps);
    const resp = await client.getEntries({
        content_type: "pageVideoSeries",
        select: "fields.slug",
        limit: 200
    });
    return resp.items.map((param)=>{
        let { fields: { slug  }  } = param;
        return slug;
    });
};
const fetchProps = async (contentfulProps, slug)=>{
    const client = (0,contentful_createClient/* default */.Z)(contentfulProps);
    const resp = await client.getEntries({
        content_type: "pageVideoSeries",
        "fields.slug": slug,
        include: 2
    });
    if (resp.total === 0) {
        return {
            video: null
        };
    }
    return {
        video: (0,contentfulSanitizer/* sanitize */.N)(resp.items[0].fields, "series")
    };
};
const contentfulSeriesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps , mode ="ssr"  } = param;
    const ContentfulSeriesPage = (param)=>{
        let { video  } = param;
        const { brandCode , resources =null  } = pageProps;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    video: video,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulSeriesPage.propTypes = {
        ...Page.propTypes
    };
    if (mode === "ssr") {
        ContentfulSeriesPage.getInitialProps = async (param)=>{
            let { query  } = param;
            const { slug  } = query;
            return fetchProps(contentfulProps, slug);
        };
        ContentfulSeriesPage.postConditions = [
            [
                (param)=>{
                    let { video  } = param;
                    return video;
                },
                (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
            ]
        ];
        return (0,pipe/* default */.Z)(ContentfulSeriesPage, WithConditions/* default */.ZP);
    }
    if (mode === "isr") {
        return ContentfulSeriesPage;
    }
    return null;
};
/* harmony default export */ var Series = (contentfulSeriesFactory);


/***/ }),

/***/ 34491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ RELEASE_NOTES_PER_PAGE; },
/* harmony export */   "_E": function() { return /* binding */ GUIDE_TYPES; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "ec": function() { return /* binding */ BRAND_CODE_SG; },
/* harmony export */   "gf": function() { return /* binding */ BRAND_CODE_LA; },
/* harmony export */   "h7": function() { return /* binding */ BRAND_CODE_OM; },
/* harmony export */   "lc": function() { return /* binding */ PUBLISHED; },
/* harmony export */   "yB": function() { return /* binding */ BRAND_CODE_GP; }
/* harmony export */ });
/* unused harmony exports BLOGS_PER_PAGE, BRAND_CODE_GN */
const RELEASE_NOTES_PER_PAGE = 20;
const BLOGS_PER_PAGE = 12;
const BRAND_CODE_GP = "gp";
const BRAND_CODE_SG = "sg";
const BRAND_CODE_GN = "gn";
const BRAND_CODE_OM = "om";
const BRAND_CODE_LA = "la";
const PUBLISHED = "Live";
const GUIDE_TYPES = {
    Guide: "guide",
    Tutorial: "tutorial"
};
const BRAND_NAMES = {
    om: "OMIQ",
    sg: "Snapgene",
    gp: "Graphpad",
    gn: "Geneious",
    la: "LabArchives"
};


/***/ }),

/***/ 68103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69591);




const HeroBrand = (param)=>{
    let { brandCode ="sg" , config , children , ...props } = param;
    const { color  } = config;
    const brandColor = (brand)=>color[brand];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: brandColor(brandCode),
        ...props,
        children: children
    });
};
HeroBrand.propTypes = {
    brandCode: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "sg",
        "gp",
        "gn",
        "om",
        "la"
    ]),
    config: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
        color: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
            gn: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            sg: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            gp: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            om: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            la: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
        })
    }),
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroBrand);


/***/ })

}]);